import * as React from "react"

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { isViewActive, navMain } from "@/components/sidebar-data"
import store from "../learning_strategists/state/store"

// Active state: inverted sidebar colors (light pill on the dark rail); in
// collapsed mode the bang!-flagged rounded-full turns the 32px square into a
// filled circle.
const ACTIVE_OVERRIDE =
  "data-active:bg-sidebar-foreground! data-active:text-sidebar! data-active:font-medium! group-data-[collapsible=icon]:data-active:rounded-full!"

export function NavMain({ mainView }) {
  const setView = (view) => (e) => {
    e.preventDefault()
    store.emit("ui:main_view:set", view)
  }

  return (
    <SidebarGroup>
      <SidebarMenu>
        {navMain.map((item) => (
          <SidebarMenuItem key={item.view}>
            <SidebarMenuButton
              asChild
              isActive={isViewActive(item.view, mainView)}
              tooltip={item.title}
              className={ACTIVE_OVERRIDE}
            >
              <a href="#" onClick={setView(item.view)}>
                <item.icon />
                <span>{item.title}</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
